import React, { useEffect, useState } from "react";
import axios from "axios";

function Select({ guide }) {

    function onPublicationSelected(event) {
        const publication_id = event.target.value;
        window.location.href = `/research/${publication_id}.html`;
    }

    const options = guide.years.map((year) => {
        return <option value={`${guide.guideType} ${year}`} key={year}>{year}</option>
    });

    return (
        <select key={guide.id} id={guide.id} onChange={onPublicationSelected}>
            <option value="" key="none"></option>
            {options}
        </select>
    );
}

function Guides({ guides }) {
    const guideList = guides.map((guide) => {
        return (
            <div>
                <h4 key={guide.id}>{guide.guideType}: <Select guide={guide} /></h4>
            </div>
        );
    });

    return (
        guideList
    );
}

export default function Research() {
    const [guides, setGuides] = useState([]);

    useEffect(() => {
        axios.get("/research.json").then((res) => {
            setGuides(res.data);
        });
    }, []);

    return (
        <div className="container">
            <div className="body1">
                <h2>Research Schedule</h2>
                <Guides guides={guides} />
            </div>
        </div>
    );
}
